
import { VenuesOrg } from '../VenuesOrg';

export class VenuesOrgPa extends VenuesOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'PA'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/pas/VenuesOrgPa.js